import { Typography, Modal } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { useDispatch } from 'react-redux';
import swapIcon from 'assets/icons/swap.svg';
import { deleteRequest } from 'state/Requests/requestSlice';

type ChangeFormModalProps = {
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  modalOpen: boolean;
  requestId: string;
  onCreateRequest: () => void;
  onClose: () => void;
  isForm: boolean;
  onLoadNewForm: () => void;
};
const ChangeFormModal = ({
  setModalOpen,
  modalOpen,
  requestId,
  onCreateRequest,
  onClose,
  isForm,
  onLoadNewForm,
}: ChangeFormModalProps) => {
  const dispatch = useDispatch();

  const changeRequestForm = () => {
    if (!isForm) {
      dispatch(deleteRequest(requestId));
      onCreateRequest();
    } else {
      onLoadNewForm();
    }

    setModalOpen(false);
  };

  const handleCancel = () => {
    onClose();
    setModalOpen(false);
  };

  return (
    <Modal
      data-cy='change-request-form'
      aria-label='change-request-form-modal'
      actionButtons={[
        {
          children: intl.get(
            'REQUEST_PAGE.LEFT_PANEL.CHANGE_FORM_ALERT.YES_CHANGE'
          ),
          color: 'warning',
          onClick: changeRequestForm,
          'data-cy': 'change-form-button',
        },
        {
          children: intl.get(
            'REQUEST_PAGE.LEFT_PANEL.CHANGE_FORM_ALERT.CANCEL'
          ),
          variant: 'tertiary',
          onClick: handleCancel,
          'data-cy': 'cancel-change-form-button',
        },
      ]}
      titleIcon={{
        src: swapIcon,
      }}
      isOpen={modalOpen}
      closeModal={() => setModalOpen(false)}
      title={intl.get('REQUEST_PAGE.LEFT_PANEL.CHANGE_FORM_ALERT.TITLE')}
      size='medium'
    >
      <Typography>
        {intl.get('REQUEST_PAGE.LEFT_PANEL.CHANGE_FORM_ALERT.DESCRIPTION')}
      </Typography>
    </Modal>
  );
};

export default ChangeFormModal;
